import {
  requestOptions,
  VIPSDataServiceURL,
} from "../Constants/GlobalConstant";
import { getMessage } from "./messages";

// Extracts label type (e.g., "V000005") from labelSessionArray for a given label name.
// labelSessionArray entries have the format "LABELNAME[LABELTYPE]".
// Returns the label type if found, otherwise null.
export function getLabelTypeForSession(label, labelSessionArray) {
  if (!label || !Array.isArray(labelSessionArray) || labelSessionArray.length === 0) {
    return null;
  }
  const match = labelSessionArray.find(entry => entry.startsWith(label + "["));
  if (match) {
    const parts = match.split("[");
    if (parts.length > 1) {
      return parts[1].replace("]", "");
    }
  }
  return null;
}

export async function isSessionValid(userId, sessionId) {
  try {
    const response = await fetch(
      `${VIPSDataServiceURL}` +
        `/Session/IsSessionValid?userId=` +
        userId +
        `&sessionId=` +
        sessionId,
      requestOptions
    );
    const data = await response.json();
    return data;
  } catch (err) {
    return false;
  }
}
export async function getUserSessionData(user, jsonObjectId) {
  // var myItem = localStorage.getItem("sessionArray");
  // localStorage.clear();
  // localStorage.setItem("sessionArray", myItem);
  var test = await fetch(
    `${VIPSDataServiceURL}` +
      `/Session/GetSessionJson?jsonObjectId=` +
      jsonObjectId +
      `&userId=` +
      user,
    requestOptions
  )
    .then((response) => {
      return response.json();
    })
    .then((data) => {
      return data;
    })

    .catch((err) => {
      return false;
    });
  return test;
}

export async function deleteUserSessionData(user, jsonObjectId) {
  try {
    const response = await fetch(
      `${VIPSDataServiceURL}/Session/DeleteSessionJson?jsonObjectId=${jsonObjectId}&userId=${user}`,
      requestOptions
    );
    const data = await response.json();
    return data; // Assuming the response contains a success indicator
  } catch (err) {
    return false;
  }
}

// export async function saveSessionString(userId, stringValue, sessionId) {
//   var test = await fetch(
//     `${VIPSDataServiceURL}` +
//       `/Session/SaveSessionString?userId=${userId}&stringId=division_id&stringValue=${stringValue}&sessionId=${sessionId}`,
//     requestOptions
//   )
//     .then((response) => {
//       return response.json();
//     })
//     .then((data) => {
//       return data;
//     })

//     .catch((err) => {
//       return false;
//     });
//   //  return test;
// }

export async function saveSessionString(userId, stringValue, sessionId) {
  try {
    const response = await fetch(
      `${VIPSDataServiceURL}/Session/SaveSessionString?userId=${userId}&stringId=division_id&stringValue=${stringValue}&sessionId=${sessionId}`,
      requestOptions
    );
    const data = await response.json();
    return data;
  } catch (error) {
    return false;
  }
}
export async function deleteUserLabelSessionData(user, jsonObjectId) {
  try {
    const response = await fetch(
      `${VIPSDataServiceURL}/Session/DeleteSessionJson?jsonObjectId=${jsonObjectId}&userId=${user}`,
      requestOptions
    );
    const data = await response.json();
    return data; // Assuming the response contains a success indicator
  } catch (err) {
    return false;
  }
}
export async function saveUserSessionData(user, jsonObjectId, localStorageD) {
  const requestOptions = {
    method: "POST",
    headers: {
      Authorization: "Basic T0VGb3JtVXNlcjpBdmVyeUAxMjM0NQ==",
      ReactApiKey: process.env.REACT_APP_API_KEY,
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      userId: user,
      jsonObjectId: jsonObjectId,
      jsonObjectData: JSON.stringify(localStorageD),
      noExpiry: true,
    }),
  };
  await fetch(
    `${VIPSDataServiceURL}` +
      `/Session/SaveSessionJson?jsonObjectId=${jsonObjectId}&` +
      `userId=${user}`,
    requestOptions
  )
    .then((response) => {
      //response.json();
    })

    .catch((err) => {});
}
export function RedirectToSourceLoginIfSessionExpired(
  userId,
  sessionId,
  isSourceOCC,
  isOrderInProgess
) {
  var Promise = isSessionValid(userId, sessionId);
  Promise.then((response) => {
    if (!response) {
      var myItem = localStorage.getItem("sessionArray");
      localStorage.clear();
      localStorage.setItem("sessionArray", myItem);
      alert(getMessage("sessionExpired"));
      if (isSourceOCC) {
        if (isOrderInProgess) {
          RedirectBackToOCCAfterInProgressOrderSessionExpired();
        } else {
          RedirectBackToOCCAfterSessionExpired();
        }
      } else {
        RedirectBackToVIPSLoginPageAfterSessionExpired();
      }
    }
  });
}
const RedirectBackToOCCAfterSessionExpired = () => {
  var path = process.env.REACT_APP_OCC_SESSION_EXPIRED_URL;
  window.location.href = path;
};

const RedirectBackToOCCAfterInProgressOrderSessionExpired = () => {
  var path = process.env.REACT_APP_OCC_ORDER_INPROGRESS_SESSION_EXPIRED_URL;
  window.location.href = path;
};
const RedirectBackToVIPSLoginPageAfterSessionExpired = () => {
  var path = process.env.REACT_APP_SITE_URL;
  window.location.href = path;
};
